import api from './axiosConfig';

/**
 * 公用設施計量服務
 */
const utilityMeterService = {
  /**
   * 獲取所有計量數據
   * @param {string} unitId - 單位ID (可選，僅查詢特定單位)
   * @returns {Promise} - 包含計量數據的響應
   */
  getAllMeterData: async (unitId) => {
    const params = unitId ? { unitId } : {};
    const response = await api.get('/utility-meters', { params });
    return response.data;
  },

  /**
   * 獲取電力計量數據
   * @param {string} unitId - 單位ID (可選，僅查詢特定單位)
   * @returns {Promise} - 包含電力計量數據的響應
   */
  getElectricityData: async (unitId) => {
    const params = unitId ? { unitId } : {};
    const response = await api.get('/utility-meters/electricity', { params });
    return response.data;
  },

  /**
   * 獲取水計量數據
   * @param {string} unitId - 單位ID (可選，僅查詢特定單位)
   * @returns {Promise} - 包含水計量數據的響應
   */
  getWaterData: async (unitId) => {
    const params = unitId ? { unitId } : {};
    const response = await api.get('/utility-meters/water', { params });
    return response.data;
  },

  /**
   * 獲取氣計量數據
   * @param {string} unitId - 單位ID (可選，僅查詢特定單位)
   * @returns {Promise} - 包含氣計量數據的響應
   */
  getGasData: async (unitId) => {
    const params = unitId ? { unitId } : {};
    const response = await api.get('/utility-meters/gas', { params });
    return response.data;
  },

  /**
   * 獲取單位用電趨勢
   * @param {string} unitId - 單位ID
   * @param {string} period - 期間 (day, week, month, year)
   * @returns {Promise} - 包含電力使用趨勢的響應
   */
  getElectricityTrend: async (unitId, period = 'month') => {
    const response = await api.get(`/utility-meters/electricity/${unitId}/trend`, {
      params: { period }
    });
    return response.data;
  },

  /**
   * 獲取單位用水趨勢
   * @param {string} unitId - 單位ID
   * @param {string} period - 期間 (day, week, month, year)
   * @returns {Promise} - 包含水使用趨勢的響應
   */
  getWaterTrend: async (unitId, period = 'month') => {
    const response = await api.get(`/utility-meters/water/${unitId}/trend`, {
      params: { period }
    });
    return response.data;
  },

  /**
   * 獲取單位用氣趨勢
   * @param {string} unitId - 單位ID
   * @param {string} period - 期間 (day, week, month, year)
   * @returns {Promise} - 包含氣使用趨勢的響應
   */
  getGasTrend: async (unitId, period = 'month') => {
    const response = await api.get(`/utility-meters/gas/${unitId}/trend`, {
      params: { period }
    });
    return response.data;
  },

  /**
   * 報告計量異常
   * @param {Object} data - 異常報告數據
   * @returns {Promise} - API響應
   */
  reportMeterIssue: async (data) => {
    const response = await api.post('/utility-meters/issues', data);
    return response.data;
  }
};

export default utilityMeterService; 